module.exports = __webpack_public_path__ + "images/twitter.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/social-media-icons/twitter.jpg
// module id = 876
// module chunks = 3